import { memo } from 'react';
import { Picture } from '@ui';
import {
  aboutApp,
  aboutAppMobile,
  appleOutlined,
  huaweiOutlined,
  rustoreOutlined,
  googlePlayOutlined
} from '@images';
import './AppBanner.scss';
import useWindowSize from '@customHooks/useWindowSize';
import {
  APP_STORE,
  GOOGLE_PLAY,
  HUAWEI_STORE,
  RUSTORE
} from '@constants/appLinks';

const AppBanner = () => {
  const { windowWidth } = useWindowSize();
  return (
    <div
      className='app-banner'
      style={{
        backgroundImage:
          windowWidth >= 768 ? `url(${aboutApp})` : `url(${aboutAppMobile})`,
        backgroundColor: '#FFDC78'
      }}
    >
      <div className='app-banner__title'>500 ₽ на первый заказ</div>
      <div className='app-banner__text'>
        из приложения при заказе
        <br />
        на сумму от 2 999 ₽<br />
        <br />
        Промокод <span className='app-banner__text__bold'>NEW500</span>{' '}
        для&nbsp;новых&nbsp;клиентов
      </div>
      <div className='app-banner__btns'>
        <a href={APP_STORE} target='_blank' rel='noreferrer'>
          <Picture
            icon={appleOutlined}
            pictureClassName='[&>img]:sm:w-8 [&>img]:sm:h-8'
            width='40'
            height='40'
            alt='appStore'
          />
        </a>
        <a href={GOOGLE_PLAY} target='_blank' rel='noreferrer'>
          <Picture
            icon={googlePlayOutlined}
            pictureClassName='[&>img]:sm:w-8 [&>img]:sm:h-8'
            width='40'
            height='40'
            alt='google play'
          />
        </a>
        <a href={HUAWEI_STORE} target='_blank' rel='noreferrer'>
          <Picture
            icon={huaweiOutlined}
            pictureClassName='[&>img]:sm:w-8 [&>img]:sm:h-8'
            width='40'
            height='40'
            alt='google play'
          />
        </a>
        <a href={RUSTORE} target='_blank' rel='noreferrer'>
          <Picture
            icon={rustoreOutlined}
            pictureClassName='[&>img]:sm:w-8 [&>img]:sm:h-8'
            width='40'
            height='40'
            alt='rustore'
          />
        </a>
      </div>
    </div>
  );
};

export default memo(AppBanner);
